import React, { useEffect, useRef } from "react"
import { Paper } from "@mui/material"
import TimeSlider from "@/components/ui/TimeSlider.jsx"
import { onMouseEnter, onMouseLeave } from "@/utils/mapUx"
import { publishSliderHeight, useLayoutBounds } from "@/features/layout/layoutBounds.jsx"

export default function GlobalTimeSliderContainer({
  map,
  sliderTicks,
  sliderPosition,
  setSliderPosition,
  shouldDisplayTimeSlider,
  setVoyageActive,
}) {
  const paperRef = useRef(null)
  const visible = Boolean(shouldDisplayTimeSlider && sliderTicks && sliderTicks.length > 0)
  const { sliderHeight, left } = useLayoutBounds()

  useEffect(() => {
    const el = paperRef.current
    if (!visible || !el) {
      publishSliderHeight(0)
      return undefined
    }
    const publish = () => publishSliderHeight(el.offsetHeight)
    publish()
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(publish)
    observer?.observe(el)
    return () => {
      observer?.disconnect()
      publishSliderHeight(0)
    }
  }, [visible])

  useEffect(() => {
    const offset = sliderHeight > 0 ? sliderHeight + 6 : 0
    document.querySelectorAll(".leaflet-bottom").forEach((control) => {
      control.style.bottom = `${offset}px`
    })
  }, [sliderHeight])

  if (!visible) {
    return null
  }

  return (
    <Paper
      key="timeslider-paper"
      id="global-timeslider"
      data-tour="timeslider"
      ref={paperRef}
      elevation={0}
      sx={{
        position: "absolute",
        bottom: 0,
        zIndex: 1100,
        bgcolor: "background.paper",
        padding: "10px 12px",
        borderRadius: "0px",
        boxSizing: "border-box",
        width: `calc(100% - ${left}px)`,
        marginLeft: `${left}px`,
      }}
      onMouseEnter={() => {
        if (map) onMouseEnter(map)
        setVoyageActive(false)
      }}
      onMouseLeave={() => {
        if (map) onMouseLeave(map)
        setVoyageActive(true)
      }}
    >
      <TimeSlider
        sliderPosition={sliderPosition}
        setSliderPosition={setSliderPosition}
        sliderTicks={sliderTicks}
      />
    </Paper>
  )
}
